import { translate } from "../../../common/providers";

export function onBeforeUnloadHandler(event) {
	const confirmationMessage = translate("document-center.ongoing-upload");
	event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
	return confirmationMessage; // Gecko, WebKit, Chrome <34
}

export const generateSubject = (projectName, additionalSubject) => {
	const base = `[Veolia GED Contrats] - ${projectName}`;
	return additionalSubject ? `${base} - ${additionalSubject}` : base;
};
